export default "__VITE_ASSET__CJCDSA9P__"